import SocialMediaShareBanner from '../../Page/SocialMediaShareBanner';

export default SocialMediaShareBanner;
